module.exports = __webpack_public_path__ + "media/nicole8.90e8c5f5.mp3";